//@flow
import React from 'react';
import Dialog from 'common/components/core/dialog';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

import defaultTheme from 'common/entity/teamMaster/EnableTeamModal.scss';

import type { TFunction } from 'react-i18next';
import { clientSelector } from 'common/redux/selectors/queryParamsSelectors';
import { connect } from 'react-redux';
import { withRouter } from 'common/components/core/router';
import PersonnelIdInput from 'common/entity/personnelMaster/PersonnelIdInput';
import PersonnelActions from 'common/redux/actions/personnelMaster';
import { PersonnelStatusEnum } from 'common/models/internal/MasterPersonnel';
import personnelMasterIds from 'common/tests/masterManagement/personnelMaster.json';

const ENTITY_NAME_ID = 'masterPersonnel';
type Props = {
    theme: Object,
    clientId: string,
    toggleView: () => void,
    enableEntity: ({ clientId: string, personnelId: string }) => Promise<void>,
    reloadData: () => void,
    t: TFunction
};
type State = {
    selectedPersonnel: ?{ id: string }
};

class EnablePersonnelModal extends React.PureComponent<Props, State> {
    state = {
        selectedPersonnel: null
    };

    handleAccept = () => {
        const { toggleView, enableEntity, clientId, reloadData } = this.props;
        const { id: personnelId } = this.state.selectedPersonnel || {};
        if (personnelId) {
            enableEntity({ clientId, personnelId })
                .then(toggleView)
                .then(reloadData)
                .catch(toggleView);
        } else {
            toggleView();
        }
    };

    setSelectedPersonnel = selectedPersonnel => {
        this.setState({ selectedPersonnel });
    };

    render() {
        const { theme, t, toggleView, clientId } = this.props;
        const entityNameId = ENTITY_NAME_ID;
        const enableEntity = t('enableEntity', {
            entityNameId
        });
        const { selectedPersonnel } = this.state;
        return (
            <Dialog
                title={enableEntity}
                theme={theme}
                active
                acceptActionLabel={enableEntity}
                onAccept={this.handleAccept}
                onCancel={toggleView}
                onDismiss={toggleView}
            >
                <h4>
                    {t('disabledEntity', {
                        entityNameId: 'personnel'
                    })}
                    :
                </h4>
                <PersonnelIdInput
                    clientId={clientId}
                    selectedPersonnel={selectedPersonnel}
                    setSelectedPersonnel={this.setSelectedPersonnel}
                    entityStatus={PersonnelStatusEnum.Inactive}
                    testId={personnelMasterIds.enablePersonnel.inputPersonnelId}
                />
            </Dialog>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const clientId = clientSelector(state, ownProps);
    return {
        clientId
    };
};

const withRedux = connect(mapStateToProps, {
    enableEntity: PersonnelActions.enableEntity
});

export default compose(
    withRouter,
    withRedux,
    themr('EnablePersonnelModal', defaultTheme),
    translate('entityManagement')
)(EnablePersonnelModal);
